<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" title="登录">
                <mt-button icon="back" slot="left" @click="$router.go(-2)"></mt-button>
                <div v-if="config.sms_register==1 || config.member_normal_register==1" class="common-btn btn" slot="right" @click="onSignup">注册</div>
            </mt-header>
        </div>
        <div class="main-content">
            <div class="topList">
                <div class="list">
                    <div
                            class="item"
                            v-for="(item, index) in items"
                            :key="index"
                            v-on:click="onClickItem(index)"
                    >
                        <label
                                class="title"
                                v-bind:class="{
					active: index === currentIndex,
					normal: index !== currentIndex
				}"
                        >{{ getTitle(item) }}</label
                        >
                    </div>
                </div>
            </div>
            <div class="top-wrapper">
                <flex-line class="input-wrapper" v-if="currentIndex === 0" :show-border="true">
                    <input v-model="username" placeholder="用户名/邮箱/手机号" type="text" />
                </flex-line>
                <flex-line v-if="currentIndex !== 0" class="input-wrapper" :show-border="true">
                    <input v-model="mobileusername" placeholder="请输入手机号"  :attr="{oninput: 'if(value.length>11)value=value.slice(0,11)'}"  type="text" />
                </flex-line>
                <flex-line v-if="currentIndex === 0 && config.captcha_status_login=='1'" class="input-wrapper" :show-border="true">
                    <input v-model="pictureCode" placeholder="请输入图片验证码" maxlength="6" />
                    <img slot="right" @click="changePictureCode" :src="pictureCodeUrl" class="countdown" >
                </flex-line>

                <flex-line v-if="currentIndex !== 0" class="input-wrapper" :show-border="true" >
                    <input v-model="code" placeholder="请输入短信验证码" type="number" :attr="{ oninput: 'if(value.length>6)value=value.slice(0,6)' }" />
                    <div slot="right" class="common-btn send-btn" @click="sendVerifyCodeMobile">{{sendStateTextMobile}}</div>
                </flex-line>
                <flex-line v-if="currentIndex === 0" class="input-wrapper" :show-border="true">
                    <input type="password" v-model="password" placeholder="请输入密码" />
                </flex-line>
            </div>
            <div class="common-btn ds-button-large mt-10 mb-10" @click="signin">登录</div>
            <div class="retrieve-wrapper">
                <span class="retrieve-item" @click="onRetrieve">忘记密码？</span>
            </div>
        </div>
        <div class="bottom-wrapper" v-if="isShowWechat || isShowSina || isShowQQ">
            <div class="auth-title-wrapper">
                <div class="auth-line"></div>
                <label class="auth-title">第三方登录</label>
                <div class="auth-line"></div>
            </div>
            <div class="auth-bottom-wrapper">
                <div class="auth-item" v-if="isShowWechat" @click="onWechat">
                    <div class="auth-item-icon"><img class="icon" src="../../../assets/image/weixin.png" /></div>
                    <label class="auth-title auth-item-title">微信</label>
                </div>
                <div class="auth-item" v-if="isShowSina" @click="onSina">
                    <div class="auth-item-icon"><img class="icon" src="../../../assets/image/weibo.png" /></div>
                    <label class="auth-title auth-item-title">微博</label>
                </div>
                <div class="auth-item" v-if="isShowQQ" @click="onTencent">
                    <div class="auth-item-icon"><img class="icon" src="../../../assets/image/qq.png" /></div>
                    <label class="auth-title auth-item-title">QQ</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { login, wechatLogin, LoginByMobile, getThirdLogin } from '../../../api/memberLogin'
import { isWechat } from '../../../util/wechat'
import { loadScript } from '../../../util/common'
import { getSmsCaptcha, checkPictureCaptcha } from '../../../api/common'
import { Indicator, Toast } from 'mint-ui'
import { mapMutations, mapActions, mapState } from 'vuex'
import flexLine from '../../flexLine'
export default {
  name: 'Login',
  data () {
    return {
      ifLoaded: false,
      uniapp: 0,
      pictureCodeUrl: '',
      pictureCode: '',
      code: '',
      verifyCodeMobile: '',
      canSendMobile: true,
      timeIntervalMobile: false,
      sendStateTextMobile: '发送',
      mobileusername: '',
      username: '',
      password: '',
      currentIndex: 0,
      items: [
        {
          id: 1,
          title: '普通登录'
        }
      ]
    }
  },
    components:{flexLine},
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      vm.utils.setCookie('referrer', encodeURIComponent(from.fullPath), 1 / 24)
    })
  },
  computed: {
    ...mapState({
      inviter_id: state => state.member.inviterId,
      config: state => state.config.config
    }),
    isShowWechat: function () {
      if ((isWechat() || this.uniapp) && this.config && this.config.weixin_isuse == 1) {
        return true
      }
      return false
    },
    isShowSina: function () {
      if (!isWechat() && !this.uniapp && this.config && this.config.sina_isuse == 1) {
        return true
      }
      return false
    },
    isShowQQ: function () {
      if (!isWechat() && !this.uniapp && this.config && this.config.qq_isuse == 1) {
        return true
      }
      return false
    }
  },
  watch: {
    mobileusername (newVal, oldVal) {
      newVal = newVal.replace(/[^\d]/g, '')
      if (!newVal) {
        this.$nextTick(() => {
          this.mobileusername = newVal
        })
      }
    },
    ifLoaded(newVal, oldVal){
      if(newVal){
      let _this = this
      uni.getEnv(function (res) {
        if (res.plus) {
          _this.uniapp = 1
        }
      })
      }
    },
  },
  beforeDestroy: function () {
    clearInterval(this.timeIntervalMobile)
  },
  created: function () {
    let _this = this
    loadScript('uniapp', 'https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js', function () {
        _this.ifLoaded = true
    })
    Indicator.close()
    getThirdLogin(this.$route.query.id).then(res => {
      let user_info = res.result.user_info
      let key = res.result.key
      if (user_info && key) {
        this.saveAuthInfo({ token: key, info: user_info })
        if (res.result.seller_info) {
          this.saveSellerAuthInfo({ token: res.result.seller_token, info: res.result.seller_info })
        }
        this.goHome()
      }
    })

    if (this.$route.query.clear) {
      this.memberLogout()
    }
    this.fetchConfig({}).then(
      res => {
          var config=res.result.config_list
          if(config.sms_login==1){
              this.items.push({id:2,title:'手机登录'})
          }
      },
      error => {
        Toast(error.message)
      }
    )
  },
  mounted () {
    let isTokenInvalid = this.$route.params.isTokenInvalid
    if (isTokenInvalid) {
      Toast('登录过期')
    }
    this.changePictureCode()
  },
  methods: {
    ...mapMutations({
      saveAuthInfo: 'memberLogin',
      saveSellerAuthInfo: 'sellerLogin',
      memberLogout: 'memberLogout'
    }),
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    changePictureCode () {
      this.pictureCodeUrl = env.API_HOST + '/Seccode/makecode?r=' + Math.random()
    },
    sendVerifyCodeMobile () {
      if (!this.mobileusername) {
        Toast('请先输入手机号')
        return
      }
      if (!this.canSendMobile) {
        return
      }
      getSmsCaptcha(2, this.mobileusername).then(res => {
        this.canSendMobile = false
        let second = 60
        Toast(res.message)
        let _this = this
        this.timeIntervalMobile = setInterval(function () {
          if (second <= 0) {
            _this.canSendMobile = true
            _this.sendStateTextMobile = '发送'
            clearInterval(_this.timeIntervalMobile)
          } else {
            _this.sendStateTextMobile = second + 's'
          }
          second--
        }, 1000)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    getTitle (item) {
      return item ? item.title : ''
    },
    isShowLine (index) {
      return index === this.currentIndex
    },
    onClickItem (index) {
      if (this.currentIndex !== index) {
        this.currentIndex = index
      }
    },
    onTencent () {
      window.location.href = env.API_HOST + '/api/oa_qq'
    },
    onSina () {
      window.location.href = env.API_HOST + '/api/oa_sina'
    },
    signin () {
      if (this.currentIndex == 0) {
        let username = this.username
        let password = this.password
        if (username.length === 0) {
          Toast('请输入用户名/邮箱/手机号')
          return
        }
        // TODO: 用户名（为手机号或邮箱）校验
        if (password.length === 0) {
          Toast('请输入密码')
          return
        }
        if (password.length < 6) {
          Toast('至少输入6位密码')
          return
        }
        Indicator.open()
        login(username, password, this.pictureCode).then(
          response => {
            Indicator.close()
            this.saveAuthInfo({ token: response.result.token, info: response.result.info })
            if (response.result.seller_info) {
              this.saveSellerAuthInfo({ token: response.result.seller_token, info: response.result.seller_info })
            }
            this.goHome()
          },
          error => {
            Indicator.close()
            Toast(error.message)
          }
        )
      } else {
        let mobileusername = this.mobileusername
        if (mobileusername.length != 11) {
          Toast('请输入11位手机号')
          return
        }
        Indicator.open()
        LoginByMobile(mobileusername, this.code).then(
          response => {
            Indicator.close()
            this.saveAuthInfo({ token: response.result.token, info: response.result.info })
            if (response.result.seller_info) {
              this.saveSellerAuthInfo({ token: response.result.seller_token, info: response.result.seller_info })
            }
            this.goHome()
          },
          error => {
            Indicator.close()
            Toast(error.message)
          }
        )
      }
    },

    goBack () {
      let isFromInfoEdit = this.$route.params.isFromInfoEdit
      let isFromShare = this.$route.params.isFromShare
      if (isFromInfoEdit || isFromShare) {
        this.$router.push('home')
      } else {
        this.$router.go((this.$route.query.clear)?-2:-1)
      }
    },

    goHome () {
      let referrer = this.getReferrer()

      if (referrer) { // 返回之前的页面
        referrer = decodeURIComponent(referrer)
        this.utils.clearCookie('referrer')
        this.$router.replace({ path: referrer })
      } else {
        this.$router.replace({ name: 'MemberIndex' })
      }
    },
    getReferrer () {
      let referrer = this.$route.query.referrer
      if (!referrer) {
        referrer = this.utils.getCookie('referrer')
      }
      if(referrer && (referrer.search('memberlogin')!=-1 || referrer.search('memberregister')!=-1 || referrer.search('memberbind')!=-1)){
          referrer='/member/index'
      }
      return referrer
    },
    onSignup () {
      this.$router.push({ name: 'HomeMemberRegister' })
    },

    onRetrieve () {
      this.$router.push({ name: 'HomeMemberForget' })
    },

    onWechat () {
      if(!this.ifLoaded){
        Toast('请等待文件加载完成')
        return
      }
        let referrer = this.getReferrer()
        if (referrer) { // 返回之前的页面
            referrer = decodeURIComponent(referrer)
        }
      if (this.uniapp) {
        uni.redirectTo({ url: 'login?inviter_id=' + this.inviter_id + '&ret_url=' + encodeURIComponent(referrer) })
        return
      }
      let ref = encodeURIComponent(referrer)
      wechatLogin(ref, this.inviter_id).then(res => {
        window.location.href = res.result
      }).catch(function (error) {
        Toast(error.message)
      })
    }

  }
}
</script>

<style scoped lang='scss'>
    .common-header{
        .btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
    }
    .ds-button-large{margin:0 $pageSpace}
    .container {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        .main-content{background: #fff;padding:1rem 0;}
        .countdown {min-width:4rem;}
        .send-btn{border:1px solid $primaryColor;color:$primaryColor;min-width: 2rem}
        .top-wrapper {
            .input-wrapper {
                display: flex;
                align-content: center;
                align-items: center;
                padding-left: 0.4rem;
                background-color: #fff;
                height: 2.2rem;
                img {
                    height: 1.75rem;width: auto;
                    margin: 0;
                    padding: 0;
                }
                input {
                    flex: 1;
                    font-size:$subFontSize;
                }
            }
        }
    }
    .retrieve-wrapper {
        margin: 0 $pageSpace;
        display: flex;
        flex-direction: row;
        font-size:$h2;
        color:$primaryColor
    }

    .bottom-wrapper {
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: flex-end;
        align-items: stretch;
    }
    .auth-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        height: 13rem;
    }
    .auth-title-wrapper {
        height: 1rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 2rem;
        margin-top:1rem;
    }
    .auth-title {
        color: $descTextColor;
        font-size:$subFontSize;
    }
    .auth-line {
        display: flex;
        flex: 1;
        height: 1px;
        background-color: #eee;
        margin-left: 0.8rem;
        margin-right: 0.8rem;
    }
    .auth-item {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }
    .auth-item-icon {
        width: 3rem;
        height: 3rem;
        border-radius:50%;
        background: #fff;
        font-size:3rem;
        box-shadow: 0px 4px 4px #e0e0e0;
        display: flex;
        justify-content: center;
        align-items: center;
        .icon{
            width:60%;
        }
    }

    .auth-item-title {
        margin-top: 0.6rem;
        color:$formInputColor
    }
    .auth-bottom-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        margin-left: 0.75rem;
        margin-right: 0.75rem;
        margin-bottom: 1rem;
    }

    .topList {
        height:2rem;
        padding:1rem $pageSpace;
        .list {
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-content: center;
            align-items: stretch;
            background-color: #fff;
        }
        .item {
            padding:0 .5rem;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
        .title {
            text-align: center;
            font-size:$h2;
            color: $formInputColor;
        }
        .active {
            color: $primaryColor;
            font-size:1.1rem;
        }
        .normal {
            color: #404245;
        }

    }
    .top-wrapper {
        margin:0 $pageSpace;
    }
</style>
